window.chengeLang = async (lang) => {
	const response = await axios.post('/lang/'+lang)
	if(response.data.result==='OK')
	{
		location.reload()
	}
}